export enum ItemType {
  HotelExactSearchParams = 'HotelExactSearchParams', // finds Hotels - 1:n

  // or

  HotelBroadSearchParams = 'HotelBroadSearchParams', // finds HotelTargetAreas - 1:n
  HotelTargetArea = 'HotelTargetArea', // finds HotelPreviews   - 1:n
  HotelPreview = 'HotelPreview', // finds Hotels   - 1:n

  // then

  Hotel = 'Hotel', // finds HotelRoomRates  - 1:n
  HotelRoomRate = 'HotelRoomRate' // Hotel + Room + Rate + Date = Exact Price
}

export type ItemId = string;

export interface ItemInterface {
  id: ItemId;
  type: ItemType;
}

export abstract class Item implements ItemInterface {
  public id: ItemId;

  public type: ItemType;
}
